/* eslint-disable react/no-unescaped-entities */

import React from 'react';
import {
  Box,
  GDSStyleObject,
  Modal,
  Button,
  HeadingText,
  UtilityText,
  ParagraphText,
  TextAction,
} from '@leagueplatform/genesis-core';

import { useConfigProperty } from '@leagueplatform/core';

import {
  TermsConditionType,
  HIGHMARK_APP_TYPE,
} from '../../types/communication-library.types';

import * as constants from '../../utils/constant';
import { getLoginBrowser } from '../../utils/index';

export function TermsCondition(props: TermsConditionType) {
  const {
    handleAcceptFun,
    handleDeclineFun,
    openTermCondition,
    handleChangeTerms,
  } = props;

  const tenantId = useConfigProperty('core.tenantId');

  return (
    <Box>
      <Modal.Root
        open={openTermCondition}
        data-testid="tearms-modal"
        onOpenChange={handleChangeTerms}
      >
        <Modal.Content
          showCloseButton
          padding={{
            '@initial': '0px 50px 10px 50px',
            '@laptop': '0px 50px 10px 50px',
            '@tablet': '30px 30px',
            '@mobile': '0px',
          }}
          css={
            {
              borderRadius: '12px',
              background: '#fff',
              height: '100%',
              overflowY: 'auto',
              '.GDS-box': {
                padding: '20px 2px 10px 2px',
                maxHeight: '65vh',
                '@mobile': {
                  maxHeight: '60vh',
                },
                overflowX: 'hidden !important',
                height: 'auto',
                WebkitOverflowScrolling: 'touch',
              },
              '@media only screen and (max-width: 480px) and (min-width: 320px)':
                {
                  '.GDS-modal': {
                    width: '100vw',
                    margin: '0px',
                    padding: '20px',
                  },
                },
            } as GDSStyleObject
          }
          width={{ '@initial': '45%', '@laptop': '45%', '@mobile': '100%' }}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <Box
            css={{
              textAlign: 'left',
              opacity: 'initial',
              height: 'auto',
              padding: '$two $three',
              overflow: 'scroll !important',
              '@media only screen and (max-width: 480px) and (min-width: 320px)':
                {
                  width: '95vw',
                  '.GDS-modal': {
                    width: '100vw',
                    margin: '0px',
                    padding: '20px',
                  },
                },

              '@mobile': {
                maxWidth: '100vw',
                width: '100%',
                height: '60vh !important',
                maxHeight: 'initial !important',
                paddingTop: ['Safari'].includes(getLoginBrowser())
                  ? '70px'
                  : '32px',
              },
            }}
          >
            <Modal.Title>
              <HeadingText
                level="display"
                size="sm"
                role="dialog"
                tabIndex={0}
                css={
                  {
                    fontSize: '$headingThree',
                    '@tablet': {
                      fontSize: '$headingFour',
                    },
                    '@mobile': {
                      fontSize: '$headingFive',
                    },
                    padding: '20px 0px',
                    color: '#2C3135',
                    letterSpacing: '0.25px',
                  } as GDSStyleObject
                }
              >
                {constants.TERMS_CONDITION_HEADING}
              </HeadingText>
            </Modal.Title>

            <UtilityText css={{ height: '350px', overflow: 'scroll' }}>
              <p>{constants.TERMS_CONDITION_DESC1}</p>
              <ul
                style={{
                  marginLeft: '5px',
                  paddingLeft: '15px',
                  listStyleType: 'initial',
                  listStyle: 'initial',
                }}
              >
                {constants.TERMS_CONDITION_LIST &&
                  constants.TERMS_CONDITION_LIST.length > 0 &&
                  constants.TERMS_CONDITION_LIST.map((item) => (
                    <li style={{ paddingBottom: '10px' }} key={item}>
                      {item}
                    </li>
                  ))}
              </ul>
              <p>{constants.TERMS_CONDITION_DESC2}</p>
            </UtilityText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {constants.TERMS_CONDITION_TITLE2}
            </HeadingText>
            <UtilityText css={{ height: '350px', overflow: 'scroll' }}>
              <p>{constants.TERMS_CONTENT}</p>
              <p>{constants.TERMS_CONTENT2}</p>
              <p>{constants.TERMS_CONTENT3}</p>
              <p>{constants.TERMS_CONTENT4}</p>
              <ParagraphText>
                <>
                  {`Please Note: (when selecting Text as your contact preference): We also offer our members the option of receiving certain member information by Short Message Service (SMS) or texting services (Text(s)). If you select to receive Texts as your contact preference, as applicable, we will send you information directly to your mobile phone. For example, if you select "Text" under Member Health Statement, you will receive Texts notifying you when your Member Health Statement is posted for viewing. When selecting Text as your contact preference, please note message and data rates may apply from your carrier (e.g. AT&T, Verizon, Sprint, etc.). The number of Texts you receive will depend on the number of options for which you sign up. You must be 18 years of age or older to use this service. To view additional information on Text messaging, go to the`}{' '}
                  <TextAction
                    tabIndex={0}
                    href={
                      tenantId === HIGHMARK_APP_TYPE.AMH
                        ? constants.TEMRS_URL2
                        : constants.TEMRS_URL
                    }
                    target="_blank"
                    css={{
                      cursor: 'pointer',
                      color: '#0074C9',
                    }}
                    aria-label=" SMS Texting Information and Help Policy (opens in a new tab)"
                  >
                    SMS Texting Information and Help Policy
                  </TextAction>
                </>
                ,{' '}
                {`posted on your health plan's website, by clicking on this link. Further, click on these following links to view your health plan's `}{' '}
                <TextAction
                  href={
                    tenantId === HIGHMARK_APP_TYPE.AMH
                      ? constants.TEMRS_URL2
                      : constants.TEMRS_URL
                  }
                  target="_blank"
                  tabIndex={0}
                  css={{
                    cursor: 'pointer',
                    color: '#0074C9',
                  }}
                  aria-label="Text Terms of Service (opens in a new tab)"
                >
                  Text Terms of Service
                </TextAction>{' '}
                and the{' '}
                <TextAction
                  href={
                    tenantId === HIGHMARK_APP_TYPE.AMH
                      ? constants.TEMRS_URL2
                      : constants.TEMRS_URL
                  }
                  target="_blank"
                  tabIndex={0}
                  css={{
                    cursor: 'pointer',
                    color: '#0074C9',
                  }}
                  aria-label=" Text Privacy Policy (opens in a new tab)"
                >
                  Text Privacy Policy{' '}
                </TextAction>
                ,{' '}
                {`which are posted on your health plan's website and also apply to Text messaging.`}
              </ParagraphText>
            </UtilityText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {constants.TERMS_CONDITION_TITLE3}
            </HeadingText>
            <UtilityText css={{ height: '350px', overflow: 'scroll' }}>
              <p>{constants.TERMS_CONTENT5}</p>
              <p>{constants.TERMS_CONTENT6}</p>
            </UtilityText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {constants.TERMS_CONDITION_TITLE4}
            </HeadingText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {constants.TERMS_CONDITION_TITLE5}
            </HeadingText>
            <UtilityText css={{ height: '350px', overflow: 'scroll' }}>
              <p>{constants.TERMS_CONTENT7}</p>
            </UtilityText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {constants.TERMS_CONDITION_TITLE6}
            </HeadingText>
            <UtilityText css={{ height: '350px', overflow: 'scroll' }}>
              <p>{constants.TERMS_CONTENT8}</p>
              <p>{constants.TERMS_CONTENT9}</p>
              <p>{constants.TERMS_CONTENT10}</p>
              <p>{constants.TERMS_CONTENT11}</p>
            </UtilityText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {constants.TERMS_CONDITION_TITLE7}
            </HeadingText>
            <UtilityText css={{ height: '350px', overflow: 'scroll' }}>
              <p>{constants.TERMS_CONTENT12}</p>
              <p>{constants.TERMS_CONTENT13}</p>
            </UtilityText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {constants.TERMS_CONDITION_TITLE8}
            </HeadingText>
            <HeadingText
              level="display"
              size="sm"
              css={
                {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFive',
                  },
                  padding: '20px 0px',
                  color: '#2C3135',
                  letterSpacing: '0.25px',
                } as GDSStyleObject
              }
            >
              {`BY CLICKING "SUBMIT"`} AFTER CLICKING THE CHECKBOX BESIDE THE
              COMMUNICATION PREFERENCES TERMS AND CONDITIONS, YOU ARE CONFIRMING
              THE FOLLOWING:
            </HeadingText>
            <UtilityText css={{ height: '350px', overflow: 'scroll' }}>
              <ul
                style={{
                  marginLeft: '5px',
                  paddingLeft: '15px',
                  listStyleType: 'initial',
                  listStyle: 'initial',
                }}
              >
                {constants.TERMS_CONDITION_LIST2 &&
                  constants.TERMS_CONDITION_LIST2.length > 0 &&
                  constants.TERMS_CONDITION_LIST2.map((item) => (
                    <li style={{ paddingBottom: '10px' }} key={item}>
                      {item}
                    </li>
                  ))}
              </ul>
              <p>{constants.TERMS_CONTENT14}</p>
            </UtilityText>
          </Box>
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'row',
                padding: '$one',
                justifyContent: 'space-evenly',
              } as GDSStyleObject
            }
          >
            <Button
              css={
                {
                  borderRadius: '99999px',
                  background: '#0074C9',
                  color: '#FFF',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '25.5px',
                  letterSpacing: '-0.2px',
                  textAlign: 'center',
                  display: 'flex',
                  padding: '12px 32px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  role: 'dialog',
                  tabIndex: '0',
                  gap: '8px',
                  '&:hover': {
                    color: '#fff',
                  },
                  '@media only screen and (max-width: 900px) and (min-width: 768px)':
                    {
                      padding: '8px 12px',
                      fontSize: '12px',
                      width: '45%',
                    },
                  '@media only screen and (max-width: 767px) and (min-width: 641px)':
                    {
                      padding: '8px 10px',
                      fontSize: '12px',
                      width: '45%',
                    },
                } as GDSStyleObject
              }
              onClick={handleAcceptFun}
            >
              {constants.ACCEPT_BTN}
            </Button>
            <Button
              css={
                {
                  borderRadius: '99999px',
                  border: '1px solid #707E89',
                  background: '#FFFFFF',
                  color: '#434B51',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '25.5px',
                  letterSpacing: '-0.2px',
                  textAlign: 'center',
                  display: 'flex',
                  padding: '12px 32px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  '&:hover': {
                    color: '#fff',
                  },
                  '@media only screen and (max-width: 900px) and (min-width: 768px)':
                    {
                      padding: '8px 12px',
                      fontSize: '12px',
                      width: '45%',
                    },
                  '@media only screen and (max-width: 767px) and (min-width: 641px)':
                    {
                      padding: '8px 10px',
                      fontSize: '12px',
                      width: '45%',
                    },
                } as GDSStyleObject
              }
              onClick={handleDeclineFun}
            >
              {constants.DECLINE_BTN}
            </Button>
          </Box>
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
